import { render, staticRenderFns } from "./uploadExample.vue?vue&type=template&id=521e594c&scoped=true"
import script from "./uploadExample.vue?vue&type=script&lang=js"
export * from "./uploadExample.vue?vue&type=script&lang=js"
import style0 from "./uploadExample.vue?vue&type=style&index=0&id=521e594c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e594c",
  null
  
)

export default component.exports